import { Title, Container, Flex, Body, styled, Heading } from '@teko/ds-desktop';
import { SearchOutlined } from '@teko/ds-icon';
import React from 'react';
import { t } from '../../i18n.es.js';

const RecentSearch = ({
  data,
  onClickSearchItem,
  isHeadingTitle = false
}) => {
  const BlockTitle = isHeadingTitle ? StyledHeading : Title;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !!data.length && /* @__PURE__ */ React.createElement(Container, {
    paddingTop: "s8",
    paddingBottom: "s8"
  }, /* @__PURE__ */ React.createElement(BlockTitle, {
    level: 2,
    marginBottom: "s8"
  }, t("T\xECm ki\u1EBFm g\u1EA7n \u0111\xE2y")), /* @__PURE__ */ React.createElement(ContentWrapper, null, data.map((history, index) => /* @__PURE__ */ React.createElement(Flex, {
    key: index,
    marginRight: "s8",
    borderRadius: "m",
    borderWeight: "l",
    borderColor: "divider",
    borderStyle: "solid",
    padding: "s8",
    maxWidth: "40vw",
    align: "center",
    onClick: () => onClickSearchItem(history.query)
  }, /* @__PURE__ */ React.createElement(SearchOutlined, {
    size: 24,
    style: { minWidth: 24 },
    color: "textSecondary"
  }), /* @__PURE__ */ React.createElement(Body, {
    width: "70%",
    line: 2,
    marginLeft: "s8"
  }, history.query))))));
};
const ContentWrapper = styled.div`
  display: -webkit-inline-box;
  width: 100%;
  overflow-x: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`;
const StyledHeading = styled(Heading)`
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
`;

export { RecentSearch };
